<div class="relative flex w-full h-full">
  <div #map class="flex-1"></div>
</div>
